import { HTTP_STATUS, isApiError, isApiResponseError, type ApiResponseError } from '@brightlocal/api-client';

/** Whether the LSG update refused the request with `400` field errors, which the customer fixes, not us. */
export const isLsgValidationError = (error: unknown): error is ApiResponseError<unknown> =>
  isApiError(error) && isApiResponseError(error) && error.status === HTTP_STATUS.VALIDATION_ERROR;
